import { DateTime } from 'luxon';
import { paymentsTypesMap } from 'config/types';
import { fromSwiftDate } from 'helpers/swiftDateFormatter';
import { useState } from 'react';
import { usePayments, usePublicAccount } from 'state';
import { FlexContainer, InfoMessageBlock, Txt } from '../index';
import Modal from '../Modal';
import UserPaymentView from '../UserPaymentView';

/**
 * UserPayments
 *
 * @return {JSX.Element}
 */
const UserPayments = ({ className, onClick }) => {
  const [viewPayment, setViewPayment] = useState(null);
  const payments = usePayments();
  const publicAccount = usePublicAccount();

  const handleClick = (item) => () => setViewPayment(item);
  const handleCLose = () => setViewPayment(null);

  return (
    <FlexContainer column gapHalf>
      {payments.data.length ? (
        Object.keys(payments.filtered.dataByDate).map((key) => {
          const dateData = payments.filtered.dataByDate[key];

          return (
            <FlexContainer column gap key={key}>
              <FlexContainer column gapHalf>
                <Txt>
                  {DateTime.fromJSDate(dateData.date).toLocaleString(
                    DateTime.DATE_FULL
                  )}
                </Txt>
                {dateData.items.map((item) => {
                  const isReceivedPayment =
                    item.paymentToUid === publicAccount.data.profileUid;
                  const timeStr = DateTime.fromJSDate(
                    fromSwiftDate(item.dateCreated)
                  ).toLocaleString(DateTime.TIME_SIMPLE);
                  const descriptionStr =
                    paymentsTypesMap[item.paymentType] || '';

                  return (
                    <InfoMessageBlock
                      key={item.paymentUid}
                      onClick={handleClick(item)}
                      icon="currency"
                      caption={`Payment ${
                        isReceivedPayment ? 'Received' : 'Sent'
                      }`}
                      title={
                        isReceivedPayment
                          ? item.paymentFromName
                          : item.paymentToName
                      }
                      description={`${timeStr} - ${descriptionStr}`}
                      highlight="green"
                    />
                  );
                })}
              </FlexContainer>
            </FlexContainer>
          );
        })
      ) : (
        <InfoMessageBlock
          title="No transactions"
          description="Payments transaction data will appear here when you make a payment or someone pays you."
        />
      )}
      {viewPayment ? (
        <Modal onClose={handleCLose} title="View Transaction" showCloseButton>
          <UserPaymentView item={viewPayment} />
        </Modal>
      ) : null}
    </FlexContainer>
  );
};

UserPayments.displayName = 'UserPayments';

export default UserPayments;
